import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\r\n<path d=\"M2 12.6H14V14H2V12.6ZM11.442 5.1973L8.6842 2.2889C8.5131 2.1138 8.2715 2 8 2C7.7285 2 7.487 2.1138 7.3187 2.2907L4.5551 5.1952C4.4109 5.3518 4.319 5.5541 4.319 5.7784C4.319 6.2599 4.7312 6.6503 5.2393 6.6503C5.2464 6.6503 5.2533 6.6494 5.2603 6.6492V6.6547H6.5V11.4473H9.5V6.6547H10.7061V6.6477C10.7243 6.6487 10.7422 6.6505 10.7608 6.6505C11.269 6.6505 11.6811 6.26 11.6811 5.7784C11.6811 5.5541 11.5891 5.3519 11.442 5.1973Z\" fill=\"#4D7CFE\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/upload.svg
// module id = P/TB
// module chunks = 14